import ClientsWithGroups from "./ClientsWithGroups"

export default  ClientsWithGroups;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/index.js